import PermissionMatrix from './PermissionMatrix';
export default PermissionMatrix;
